/**
 * The player's explicit settings choice, or `null` to follow the OS. The
 * override wins either way (STYLEGUIDE §12) — a player whose OS preference is
 * really about other apps can have the surge back.
 */
let override: boolean | null = null;

function osPrefersReducedMotion(): boolean {
  return globalThis.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
}

/** Honour "reduce motion": no sparks, no surge, no flow dashes. */
export function prefersReducedMotion(): boolean {
  return override ?? osPrefersReducedMotion();
}

export function setReducedMotionOverride(value: boolean | null): void {
  override = value;
  syncReducedMotionAttr();
}

/**
 * Keep the stylesheet's flag in step with the effective preference. CSS keys
 * off this one attribute rather than the media query, so the settings switch
 * can also *restore* motion the OS turned off.
 */
export function syncReducedMotionAttr(): void {
  document.documentElement.toggleAttribute('data-reduce-motion', prefersReducedMotion());
}

/** Desktop-style pointers get the hover ghost; touch doesn't. */
export function canHover(): boolean {
  return globalThis.matchMedia?.('(hover: hover)').matches ?? false;
}
